export default "__VITE_ASSET__zHYl9D41__"